import { Button, CircularProgress, Box, Dialog, DialogActions, Tabs, Tab, DialogContent, Divider, Grid, IconButton, Card, capitalize, ButtonGroup } from '@mui/material'
import React, { useEffect, useState } from 'react';
import PageContainer from '../components/PageContainer';
import { getResourceData, getToken, downloadFile } from '../redux/api/system';
import { Formik, Form } from 'formik';
import { useSnackbar } from 'notistack';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import TextInput from '../components/common/TextInput';
import SelectInput from '../components/common/SelectInput';
import { Add, Delete, Edit, Label } from '@mui/icons-material';
import { dataTypeOptions } from '../util';
import { useParams } from 'react-router-dom'
import { dataOne, dataTwo, dataThree, dataFour, dataFive, dataSix, dataSeven } from '../tests/viewTestData';
import LineChart from '../components/LineChart';
import BarChart from '../components/BarChart';
import PieChart from '../components/PieChart';
import MultipleSelectChip from '../components/common/MultipleSelectChip';
import { number } from 'yup';
import AreaBump from '../components/AreaBump';
import MUIDataTable from 'mui-datatables';
import { connect } from 'react-redux';
import TableRenderers from 'react-pivottable/TableRenderers';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import {  } from 'react-pivottable/Utilities';
import createPlotlyComponent from 'react-plotly.js/factory';
import Plot from 'react-plotly.js';
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import PivotTableUI from 'react-pivottable/PivotTableUI';
import { openBase64InNewTab } from '../util';

// const Plot = createPlotlyComponent(window.Plotly);

const PlotlyRenderers = createPlotlyRenderers(Plot);

const Views = ({ user }) => {
    const [ isDownloading, setIsDownloading ] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [ processing, setProcessing ] = useState(false);
    const [ xAxis, setXAxis ] = useState("");
    const [ yAxis, setYAxis ] = useState("");
    const [ chartData, setChartData ] = useState([]);
    const [ presentView, setPresentView ] = useState(0);
    const [ barOtherData, setBarOtherData ] = useState({});
    const [ tableData, setTableData ] = useState([]);
    const [ barChartData, setBarChartData ] = useState([]);
    const [ areaChartData, setAreaChartData ] = useState([]);
    const [ count, setCount ] = useState(0);
    const [ chartSelect, setChartSelect ] = useState("");
    const [ resetField, setResetField ] = useState(false);
    const [ section, setSection ] = useState(0);
    const sections = ['Data View', 'Advanced Table'];

    const [ resourceData, setResourceData ] = useState({});
    const [ columns, setColumns ] = useState([]);

    const [ pivot, setPivot ] = useState();

    // const columns = [
    //     { 
    //         field: 'sn', headerName: 'S/N', width: 100, sortable: false,
    //         renderCell: (params) => (
    //             <p
    //                 style={{ margin: 'auto' }}
    //             >
    //                 {params.api.getRowIndex(params?.row?.resourceID) + 1}
    //             </p>
    //         )
    //     },
    //     { field: 'resourceName', headerName: 'Resource Name', width: 400 },
    //     { field: 'description', headerName: 'Description', width: 400 },
    //     { field: 'tags', headerName: 'Tags', width: 400 },
    // ];

    const defualtFormValues = {
        dataModels: "",
        dataViews: "",
        xaxis: "",
        multiple_y: [],
    };

    const params = useParams();

    const firstCapital = (str) => {
        if( str.length > 0 ){
            let ans = str[0].toUpperCase();
            for( let x = 1; x < str.length; x++ ){
            ans += str[x]
            }
            return ans;
        };
        return "";
    };

    const firstLowercase = (str) => {
        if ( str.length > 0 ){
            let ans = str[0].toLowerCase();
            for( let x = 1; x < str.length; x++ ){
            ans += str[x]
            }
            return ans;
        };
        return "";
    };


    const targetId = [
        { id: '1', name: 'DataView' },
        { id: '2', name: 'DataSet' },
        { id: '3', name: 'PositionFile' },
        { id: '4', name: 'PowerBI' },
        { id: '5', name: 'ExternalUrl' },
    ];

    const dynamicColumns = (obj) => {
        let ans = [];

        ans.push({ 
            field: 'sn', headerName: 'S/N', width: 100, sortable: false,
            renderCell: (params) => (
                <p
                    style={{ margin: 'auto' }}
                >
                    
                </p>
            )
        });
       
        let boxOfKeys = Object.keys(obj)
        for ( let x = 1; x < Object.keys(obj).length; x++ ){
            ans.push({ 
                field: boxOfKeys[ x - 1 ],
                headerName: firstCapital(boxOfKeys[ x - 1 ]),
                minWidth: 250,
             })
        };


        return ans;
    };

    const normalizeData = (obj, arr) => {
        let ans = [];
        for(let x = 0; x < arr.length; x++) {
            ans.push({
                "x": arr[x],
                "y": obj[arr[x]]
            })
        }
        return ans;
    };

    const sortChartData = (arr, isLineChart) => {
        
        let ansMain = [];

        for( let y = 0; y < arr[1].length; y++ ){
            let ans = {};

            let boxOfKeysX = Object.keys(arr[0][0]);
            let boxOfKeysY = Object.keys(arr[1][y][0]);

            let str = `${boxOfKeysX} - ${boxOfKeysY}`;
            ans["id"] = str;
            if( isLineChart )
            ans["color"] = "hsl(330, 70%, 50%)";
            let dataList = [];

            for( let x = 0; x < arr[0].length; x++ ){
                dataList.push({
                    "x": arr[0][x][boxOfKeysX],
                    "y": arr[1][y][x][boxOfKeysY]
                });
            };

            ans["data"] = dataList;
            ansMain.push(ans);
        };

        return ansMain;
    };

    const sortBarChatData = (arr) => {
        let ansMain = [];
        let arrColors = [ "hsl(10, 70%, 50%)", "hsl(160, 70%, 50%)", "hsl(169, 70%, 50%)", "hsl(178, 70%, 50%)", "hsl(113, 70%, 50%)", "hsl(317, 70%, 50%)" ]

        for( let x = 0; x < arr[0].length; x++ ){

            let ans = {};

            let boxOfKeys = Object.keys( arr[0][x] );

            ans[boxOfKeys[0]] = arr[0][x][boxOfKeys[0]];

            for( let y = 0; y < arr[1].length; y++ ){

                let boxOfKeysOthers = Object.keys( arr[1][y][x] );
                let rand = Math.floor((Math.random() * 5))

                ans[boxOfKeysOthers[0]] = arr[1][y][x][boxOfKeysOthers[0]]
                ans[`${boxOfKeysOthers[0]}Color`] = arrColors[rand];


            }

            ansMain.push(ans);
        };

        return ansMain;
    };


    const axisOption = (arr) => {
        let ans = [];
        
        if(arr != undefined){
            let boxOfKeys =  Object.keys(arr[0] != undefined ? arr[0] : {});

            for( let x = 0; x < boxOfKeys.length; x++ ){
                ans.push({
                    id: `${firstCapital(boxOfKeys[x])}`,
                    value: boxOfKeys[x],
                })
            };
        };
        
        
        return ans;
    };

    const axisArray = (arr) => {
        // return arr != undefined ? Object.keys(arr[0] != undefined ? arr[0] : {}).map((keys) => { if(typeof(arr[0][keys]) == 'number') return `${firstCapital(keys)}` }) : [];

        let ans = [];

        if(arr != undefined) {
            let boxOfKeys =  Object.keys(arr[0] != undefined ? arr[0] : {});

            for( let x = 0; x < boxOfKeys.length; x++ ){

                if( typeof(arr[0][boxOfKeys[x]]) == 'number' ){
                    ans.push(firstCapital(boxOfKeys[x]))
                }
            }
        }

        return ans;
    };


    const sortChosenDatasets = (xaxis, yaxis, arr) => {
        let ans = [];
        let xans = [];
        let yans = [];

        for ( let y = 0; y < yaxis.length; y++ ){
            let arrY = [];

            for( let x = 0; x < arr.length; x++ ){
                let xobj = {};
                let yobj = {};
    
                xobj[xaxis] = arr[x][xaxis];
                yobj[firstLowercase(yaxis[y])] = arr[x][firstLowercase(yaxis[y])];
    
                if(y == 0)
                xans.push(xobj);

                arrY.push(yobj);
            };

            yans.push(arrY);
        };
        

        ans.push(xans);
        ans.push(yans);

        return ans;
    };


    const importData = {
        "dataOne": dataOne.Data,
        "dataTwo": dataTwo.Data,
        "dataThree": dataThree,
        "dataFour": dataFour,
        "dataFive": dataFive,
        "dataSix": dataSix.Data,
        "dataSeven": dataSeven,
    };
    
    const handleSubmit = ({ ...values }) => {

        // values.dataModels
        setXAxis(firstCapital(values?.xaxis != undefined ? values?.xaxis : ""));
        let str = values?.multiple_y.map((y) => (firstCapital(y))).join(' ');
        setYAxis(str);



        //setTableData(importData[values?.dataModels]);

        if( (values?.xaxis?.length > 0) && (values?.multiple_y?.length > 0) && ( values?.dataViews == "Line Chart" ) ){
            let plots = sortChartData(sortChosenDatasets(values?.xaxis, values?.multiple_y, resourceData?.data || []), true);
            setChartData(plots);
        };

        if ( (values?.xaxis?.length > 0) && (values?.multiple_y?.length > 0) && ( values?.dataViews == "Area Bump Chart" ) ){
            let plots = sortChartData(sortChosenDatasets(values?.xaxis, values?.multiple_y, resourceData?.data || []), false);
            setAreaChartData(plots);
        }

        if( (values?.xaxis?.length > 0) && (values?.multiple_y?.length > 0) && ( values?.dataViews == "Bar Chart" ) ) {

            let ans = {};

            ans.listOfKeys = values.multiple_y.map((entry) => (firstLowercase(entry)));
            ans.index = values?.xaxis;
            ans.titleXAxis = firstCapital(values?.xaxis);
            ans.titleYAxis = values?.multiple_y.join(" ");

            let secondAns = [];
            if( values.multiple_y.length == 1 ){
                secondAns.push({
                    match: {
                        id: firstLowercase(values.multiple_y[0])
                    },
                    id: 'dots',
                });
            }
            else {
                secondAns.push({
                    match: {
                        id: firstLowercase(values.multiple_y[0])
                    },
                    id: 'dots',
                });
                secondAns.push({
                    match: {
                        id: firstLowercase(values.multiple_y[1])
                    },
                    id: 'lines',
                });
            };

            ans.matchKeys = secondAns;

            setBarOtherData(ans);
            
            let ploting = sortBarChatData(sortChosenDatasets(values?.xaxis, values?.multiple_y, resourceData?.data || []));
            setBarChartData(ploting);
        };


        if(values?.dataViews == "Line Chart"){
            setPresentView(1);
        }
        else if(values?.dataViews == "Bar Chart"){
            setPresentView(2);
        }
        else if(values?.dataViews  == "Pie Chart"){
            setPresentView(3);
        }
        else if( values?.dataViews == "Area Bump Chart" ){
            setPresentView(4);
        }
        else {
            setPresentView(0);
        }

        //console.log(plots);
    };

    const handleChange = (values) => {
        setTableData(importData[values?.dataModels]);
    };

    const handleGraphChange = (values) =>  {
        // console.log(values);
        setChartSelect(values.dataViews);
    }

    // const init = () => {
    //     setChartData(dataThree);
    // }

    // useEffect(() => {
    //     init();
    // }, [])

    // console.log(sortChosenDatasets("year", "quater", dataOne.Data))
    // { field: 'roleName', headerName: 'Role Name', width: 300 },

    // const init = async () => {
    //     try {
    //         setProcessing(true)
    //         const resp = await getList("resources");
    //         if(resp?.responseCode === "00") {
    //             setRecords(resp?.listing || [])
    //         } else {
    //             enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
    //         }

    //     }
    //     catch (err) {
    //         enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
    //     }
    //     finally {
    //         setProcessing(false)
    //     }
    // }

    const testNames = [ 'Fine', 'Wine', 'computer', 'music' ]


    const formOptions = {
        dataViewOptions: [
            {
                name: "Data Table",
            },
            {
                name: "Line Chart"
            },
            {
                name: "Bar Chart"
            },
            // {
            //     name: "Pie Chart"
            // },
            {
                name: "Area Bump Chart"
            }
        ],
        dataModleOptions: [
            {
                name: "Data sets One",
                value: "dataOne"
            },
            {
                name: "Data sets Two",
                value: "dataTwo"
            },
            {
                name: "Data sets Three",
                value: "dataSix"
            }
        ]
    }

    const generateRandom = () => {
        var length = 8,
            charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
            retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
    };

    const downloadResourceFile = async (args) => {
        try {
            setIsDownloading(true)
            const res = await downloadFile(args);
            // openBase64InNewTab(res?.base64String, false, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");

            let blobUrl = URL.createObjectURL(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            const downloadLink = document.createElement("a");
            downloadLink.href = blobUrl;
            downloadLink.download = resourceData?.DocumentFileName || "resource.xlsx";
            downloadLink.click();
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.error || 'An error occurred', { variant: 'error' })
        }
        finally {
            setIsDownloading(false)
        }
    };

    const getResourceDetails = async (resourceID) => {
        try {
            setProcessing(true)

            const userId = user?.userData?.user_data?.userID || 'public';
            let token = null;
            if(userId == "public") {
                const resp = await getToken();
                if(resp?.responseCode === "00") {
                    token = resp?.token || null    
                } else {
                    enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
                }
            }

            const resp = await getResourceData(resourceID, token);
            if(resp?.ResponseCode === "00" || resp?.responseCode === "00") {
                const resource = resp?.Resource || resp?.resource || {};
                const data = resp?.Data || resp?.data || [];
                setResourceData({
                    ...resource,
                    data,
                })
                const dataStructure = data?.[0] || {}
                // console.log("This is the return of the data variable: ", data);
                // console.log("This is the resource data: ", resource);
                // console.log("decided to console the entire response: ", resp);
                setTableData(data);
                
                setColumns([
                    {
                        name: 'id',
                        label: 'SN',
                        options: {
                            filter: false,
                            sort: false,
                            minWidth: '10px',
                            maxWidth: '10px',
                            download: true,
                            draggable: false,
                            setCellProps: () => ({ style: { minWidth: "10px", maxWidth: "10px" }}),
                            customBodyRender : (value, tableMeta, update) => {
                                let rowIndex = Number(tableMeta.rowIndex) + 1;
                                return ( <span>{rowIndex}</span> )
                            }
                        },
                    },
                    ...Object.keys(dataStructure).map((key) => ({
                        name: key,
                        label: capitalize(key),
                        options: {
                            filter: true,
                            sort: true,
                            download: true,
                            draggable: true,
                            display: true,
                            setCellProps: () => ({ style: { 
                                justifyContent: 'right',  flexDirection: 'row',
                            }}),
                            customBodyRender : (value, tableMeta) => {
                                const isNumber = Boolean(typeof(value) == 'number');
                                return ( 
                                    <span style={{ display: 'block', textAlign: isNumber ? 'right' : 'initial'  }}>{value}</span> 
                                )
                            },
                        }
                    }))
                ])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || resp?.ResponseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false)
        }
    };

	const options = {
		filter: true,
		filterType: "multiselect",
		responsive: 'standard',
		tableBodyHeight: '600px',
		tableBodyMaxHeight: '',
		draggableColumns: { enabled: true },
		resizableColumns: true,
		downloadOptions: { filename: `${resourceData?.ResourceName}.csv`, separator: ',' },
        rowsPerPage: 15,
		rowsPerPageOptions: [15, 25, 50, 100],
        selectableRows: 'none',
	};

    useEffect(() => {
        if(params?.resourceID) getResourceDetails(params.resourceID)
    }, [params])

    return (
        <PageContainer pageTitle='View Data' processing={processing}>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h1 className="wow fadeInUp text-uppercase conference mb-2 mt-2" data-wow-delay="1.6s">{resourceData?.ResourceName}</h1>
                                {/* <p className="wow bounceIn" data-wow-delay="0.9s">{resourceData?.Description}</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <div className="services-area section-padding pt-3 chart">
                <div className="container">
                    <div className='row' >
                        <div className='col-12 data-details'>
                            <p><span>Description:</span>{resourceData?.Description}</p>
                        </div>
                        {/* <div className='col-12 col-lg-6 data-details'>
                            <p><span>Resource Group:</span></p>
                        </div>
                        <div className='col-12 col-lg-6 data-details'>
                            <p><span>Domain:</span></p>
                        </div> */}
                        <div className='col-12 col-lg-6 data-details'>
                            <p><span>Frequency:</span>{capitalize(resourceData?.Frequency || '')}</p>
                        </div>
                        <div className='col-12 col-lg-6 data-details'>
                            <p><span>Last Updated:</span>{resourceData?.LastUpdated}</p>
                        </div>
                        {/* <div className='col-12 col-lg-6 data-details'>
                            <p><span>Dataset:</span></p>
                        </div>
                        <div className='col-12 col-lg-6 data-details'>
                            <p><span>Domain:</span></p>
                        </div> */}
                    </div>
                    {
                        (resourceData?.ResourceType == 4 || resourceData?.ResourceType == 5)
                        ?
                        <div className='fluid-container'>
                            <div className='row'>
                                <div className="col-12 text-center">
                                    {
                                        resourceData.Url.length == 0
                                        ?
                                        <h2 style={{ marginTop: "50px" }}>No URL provided in the the Resource Payload</h2>
                                        :
                                        <iframe 
                                            title="IDSP" width="1140" height="541.25" src={resourceData.Url}
                                            frameborder="0" allowFullScreen="true"
                                        ></iframe>
                                    }
                                </div>
                            </div>
                        </div>
                        :
                        (resourceData?.ResourceType == 3)
                        ?
                        <div className='fluid-container'>
                            <div className='row h-50' >
                                {/* <div className='col-12 mb-3 mt-2 d-flex align-items-center'>
                                    <p>Click the button below to download resource file..</p>
                                </div> */}
                                <div className='col-12 mb-3 mt-2 align-items-center '>
                                    <p>Click the button below to download resource file..</p>
                                    <Button 
                                        className='p-1' 
                                        startIcon={<FileDownloadDoneIcon />} 
                                        onClick={() => downloadResourceFile(resourceData?.DocumentFileName ?? "")} 
                                        variant={"contained"}
                                        disabled={isDownloading}
                                        style={{ width: '270px', fontSize: "1.1em", height: '60px', textTransform: 'none' }}
                                    >
                                        {isDownloading ? <CircularProgress size={20} /> : null}
                                        {isDownloading ? "Downloading..." : "Download Resource File"}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='fluid-container'>
                            <div className='row' >
                                <div className='col-12 mb-3 mt-2'>
                                    <ButtonGroup variant="outlined" size="small " fullWidth>
                                        { sections?.map((sec, index) => <Button key={index} onClick={() => setSection(index)} variant={section == index ? "contained" : 'outlined'}>{sec}</Button> ) } 
                                    </ButtonGroup>
                                </div>
                            </div>
                            <div className='row' >
                                <div className='col-12 data-table'>
                                    {
                                        section == 0 &&
                                        <MUIDataTable
                                            data={resourceData?.data || []} 
                                            checkbox={false}
                                            columns={columns}
                                            options={options}
                                        />
                                    }
                                    {
                                        section == 1 &&
                                        <PivotTableUI
                                            data={resourceData?.data || []}
                                            renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
                                            onChange={s => setPivot(s)}
                                            {...pivot}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    
                    
                </div>
                
                {/* <div className="container">
                    <div className='row' >
                        <div className='col-12'>
                            <Card className='custom-card p-3'>
                                <Tabs value={0} centered>
                                    <Tab label="Select from Datasets" />
                                </Tabs>
                                <Formik
                                    initialValues={defualtFormValues}
                                    enableReinitialize
                                    onSubmit={handleSubmit}
                                >
                                    {({ isSubmitting, values, setFieldValue }) => (
                                        <Form>
                                            <Grid container spacing={3} className="mt-1">
                                                <Grid item xs={12} container spacing={3}>                                 
                                                    <Grid item xs={0} md={3} lg={3}>
                                                        // {/* <SelectInput field="value" label='List of Available Data Models' onChange={handleChange(values)} fieldDisplay='name' id='dataModels' options={formOptions.dataModleOptions} />                                     
                                                    </Grid>
                                                    <Grid item xs={12} md={6} lg={6}>
                                                        <SelectInput field="name" label='Select Data View' onChange={handleGraphChange(values)} fieldDisplay='name' id='dataViews' options={formOptions.dataViewOptions} />   
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Divider />
                                                    </Grid>
                                                    {
                                                        (chartSelect == "Line Chart" || chartSelect == "Bar Chart" || chartSelect == "Area Bump Chart") &&
                                                         <Grid item xs={12} container spacing={3}>
                                                            <Grid item xs={12} md={6} lg={6}>
                                                                <SelectInput field="value" label='X Axis' fieldDisplay='id' id='xaxis' options={axisOption(tableData)} />   
                                                            </Grid>
                                                            <Grid item xs={12} md={6} lg={6}>
                                                                <MultipleSelectChip entries={axisArray(tableData)} label="Y Axis" id="multiple_y" refresh={resetField} />   
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                    
                                                </Grid>
                                                <Grid item xs={12} container justifyContent='center'>
                                                    <Button variant='contained' type="submit" style={{ width: '350px' }} startIcon={<Add />}>
                                                        Display 
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Form>
                                    )}
                                </Formik>
                            </Card>
                        </div>
                    </div>
                </div> */}
                <div className='container'>
                    <div className="row">
                        <div className='col-12 mt-4 h-100 p-3'>
                            {/* <Card className='custom-card p-3'>
                                <div style={{ height: '100vh', width: '100%', textAlign: 'center' }}>
                                    {
                                        presentView === 0 && 
                                        <Box style={{ height: '100vh', width: '100%', textAlign: 'center' }}>
                                            <Tabs value={0} centered style={{ padding: '10px' }}>
                                                <Tab label="Data Table" />
                                            </Tabs>
                                            <DataGrid 
                                                className=''
                                                columns={dynamicColumns(tableData[0] ? tableData[0] : {} )}
                                                // getRowId={row => row.resourceID}
                                                rows={tableData}
                                                checkboxSelection={false}
                                                getRowId={(row) =>  generateRandom()}
                                                disableSelectionOnClick
                                                components={{ Toolbar: GridToolbar }}
                                            />
                                        </Box> 
                                    }
                                    {
                                        presentView == 1 &&
                                        <Box style={{ height: '100vh', width: '100%', textAlign: 'center' }}>
                                            <Tabs value={0} centered style={{ padding: '10px' }}>
                                                <Tab label="Line Chart" />
                                            </Tabs>
                                            <LineChart 
                                                data={chartData} 
                                                xAxisTitle={""}
                                                yAxisTitle={""}
                                            />
                                        </Box>
                                    }
                                    {
                                        presentView == 2 && 
                                        <Box style={{ height: '100vh', width: '100%', textAlign: 'center' }}>
                                            <Tabs value={0} centered style={{ padding: '10px' }}>
                                                <Tab label="Bar Chart" />
                                            </Tabs>
                                            <BarChart 
                                                data={barChartData}
                                                listOfKeys={barOtherData.listOfKeys}
                                                index={barOtherData.index} 
                                                matchKeys={barOtherData.matchKeys}
                                                titleXAxis={barOtherData.titleXAxis}
                                                titleYAxis={barOtherData.titleYAxis}
                                            />
                                        </Box>
                                    }
                                    {
                                        presentView == 3 &&
                                        <PieChart data={dataFive}/>
                                    }
                                    {
                                        presentView == 4 &&
                                        <Box style={{ height: '100vh', width: '100%', textAlign: 'center' }}>
                                            <Tabs value={0} centered style={{ padding: '10px' }}>
                                                <Tab label="Area Chart" />
                                            </Tabs>
                                            <AreaBump data={areaChartData} />
                                        </Box>
                                    }
                                </div>
                            </Card> */}
                        </div> 
                    </div>
                </div>
            </div>
           
            
        </PageContainer>
    );
}

export default connect(({ user }) => ({ user }))(Views);